module.exports = __webpack_public_path__ + "img/3.b12b7164.gif";